import { useTranslation } from '@shared/localization';
import cn from 'clsx';
import { useState, PropsWithChildren } from 'react';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';

interface OrderIdProps extends PropsWithChildren {
  readonly extraClassName?: string;
  readonly orderNumber?: string | number;
}

export function OrderId({
  extraClassName,
  children,
  orderNumber,
}: OrderIdProps) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  return (
    <span
      className={cn('font-app break-words m-0 cursor-pointer', extraClassName)}
      onClick={() => setVisible(!visible)}
    >
      {visible ? orderNumber?.toString() : t('Order ID')}
      {visible ? (
        <BiChevronUp className="inline-block text-2xl" />
      ) : (
        <BiChevronDown className="inline-block text-2xl" />
      )}
      {children}
    </span>
  );
}
